<template>
	<nav-list :nav="nav" :_class="`main-nav -prefixed ${_class}`" />
</template>

<script>
import NavList from '@/Components/NavList';
import * as Util from '@/Util';
import { mapGetters } from 'vuex';

export default {
	mounted() {
		this.checkMenuLinks();
	},

	components: {
		NavList
	},

	props: {
		_class: {
			type: String,
			required: false
		}
	},

	data() {
		return {
			nav: [
				// {
				// 	title: 'Sobre mim',
				// 	modal: 'modalUser',
				// },
				// {
				// 	title: 'Fale Conosco',
				// 	modal: 'modalContact',
				// },
				{
					title: 'Início',
					url: '/',
					tag: 'inicio'
				},
				{
					title: 'Sobre o Empreendimento',
					url: '#sobre',
					tag: 'sobre'
				},
				{
					title: 'Galeria de Imagens',
					url: '#galeria',
					tag: 'galeria'
				},
				{
					title: 'Localização',
					url: '#localizacao',
					tag: 'localizacao'
				},
				{
					title: 'Plantas',
					url: '#plantas',
					tag: 'plantas'
				}
			]
		};
	},
	methods: {
		/**
		 * Checando se os links do menu podem ser visíveis.
		 */
		checkMenuLinks() {
			/**
			 * @param {string} tagLink
			 * Filtro que checa os endereços listados em this.nav e retorna um objeto
			 * caso seja um encontrado um correspondente ao tagLink informado.
			 */
			const fil = tagLink => this.nav.find(link => link.tag == tagLink);

			/**
			 * Retorna o index de um objeto em **this.nav**
			 */
			const indexOf = obj => this.nav.indexOf(obj);

			const productHas = Util.getGalleryMethod;

			let sobre = fil('sobre');
			let galeria = fil('galeria');
			let localizacao = fil('localizacao');
			let plantas = fil('plantas');

			const activeItem = (item, bool = true) => {
				if (!bool) this.nav.splice(indexOf(item), 1);
			};

			const desactiveItem = item => activeItem(item, false);

			/**
			 * Verificações das URLS necessárias para a página.
			 */

			if (this.product.description) activeItem(sobre);
			else desactiveItem(sobre);

			if (productHas('images', this.product)) activeItem(galeria);
			else desactiveItem(galeria);

			if (this.product.googleMaps) activeItem(localizacao);
			else desactiveItem(localizacao);

			if (productHas('plants', this.product)) activeItem(plantas);
			else desactiveItem(plantas);
		}
	},
	computed: {
		/**
		 * Mapeando o produto para a página.
		 */
		...mapGetters('Product', ['product'])
	}
};
</script>

<style lang="stylus"></style>
